import { Link } from "react-router-dom";
import { ArrowRight, Lightbulb, Users, Cog, HeadphonesIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

const approach = [
  { icon: Lightbulb, title: "Collaborative Discovery", description: "We work closely with you to understand your unique challenges and opportunities." },
  { icon: Users, title: "Strategic Planning", description: "Our experts craft a tailored roadmap aligned with your business objectives." },
  { icon: Cog, title: "Expert Implementation", description: "Our skilled teams deliver solutions with precision and quality." },
  { icon: HeadphonesIcon, title: "Ongoing Support", description: "We stand by you with continuous support and optimization." },
];

export function ApproachSection() {
  return (
    <section className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12">
          <div className="max-w-2xl">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600 mb-4">
              Our Methodology
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 font-['Outfit']">
              Our Consulting Approach
            </h2>
          </div>
          <Link to="/consulting-approach" className="mt-4 md:mt-0">
            <Button 
              variant="outline"
              className="border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white rounded-none"
            >
              Learn More About Our Approach
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {approach.map((item, idx) => (
            <div key={item.title} className="relative">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-blue-100 flex items-center justify-center">
                  <item.icon className="w-6 h-6 text-blue-700" />
                </div>
                <span className="text-5xl font-black text-slate-100 font-['Outfit']">
                  {String(idx + 1).padStart(2, '0')}
                </span>
              </div>
              <h3 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed font-['Plus_Jakarta_Sans']">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
